module.exports = __webpack_public_path__ + "img/hazard-concrete-left.b4a8c4e6.png";